<template>
  <div class="game">
    <MembersStatus :members="members" :isDecidedTheme="isDecidedTheme" :votes="votes" />
    <TalkTheme :room_id="$route.params.room_id" :user="user" :members="members" :isOwner="isOwner" :stateIndex="stateIndex" :theme="theme" />
    <Timer v-show="false" />
    <Chat :room_id="$route.params.room_id" />
  </div>
</template>
<script>
import firebase from 'firebase'

import TalkTheme from '@/components/TalkTheme/Main.vue'
import MembersStatus from '@/components/MembersStatus.vue'
import Chat from '@/components/Chat.vue'
import Timer from '@/components/Timer.vue'


export default {
  name: 'game',
  components: {
    TalkTheme,
    MembersStatus,
    Chat,
    Timer
  },
  data() {
    return {
      db: null,
      user: null,
      room: {
        id: null
      },
      members: null,
      isOwner: false,
      stateIndex: null,
      votes: [],
      theme: null,
      isDecidedTheme: null
    }
  },
  methods: {
  },
  created() {
    this.db = firebase.firestore();
    this.room.id = this.$route.params.room_id;

    firebase.auth().onAuthStateChanged((user)=>{
        if (user) {
            // ログイン中
            this.user = user;

            // ownerかどうか
            this.db.collection('rooms').doc(this.room.id).get().then(doc => {
              this.isOwner = (this.user.uid === doc.data().owner);
            });
        }
    });

    this.db.collection('rooms').doc(this.room.id).onSnapshot((doc)=>{
      const data = doc.data();
        this.members = data.members;
        this.stateIndex = data.stateIndex;
        this.theme = data.theme;
        this.isDecidedTheme = data.isDecidedTheme;
        this.votes = data.votes;
        // this.points = data.points;
    });
  }
}
</script>
<style scoped>
</style>
